import { Grid, InputLabel } from '@material-ui/core';
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { getMotHistory } from '../../../../Core/Service/ReportScreens-service';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import Alert from '@material-ui/lab/Alert';
import ErrorIcon from '@material-ui/icons/Error';
import './motHistory.scss';
import { SecondaryButton, TextBox } from '../../../../Core/FormInput';

var dateInPast = function (firstDate) {
    if (firstDate && new Date(firstDate).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0)) {
        return true;
    }
    return false;
};

const MotHistoryScreen = (props) => {
    const [state, setState] = useState({
        dvla: null,
        lcvMot: null,
        hgvMOT: null,
        errors: {},
        isResponse: false
    });
    const pullMotHistory = async (regNo, FranchiseCode) => {
        if (props.regNo || regNo) {
            const res = await getMotHistory(regNo || props.regNo, props.FranchiseCode || '');
            setState((st) => ({
                ...st,
                dvla: res.data.dvla.response,
                lcvMot: res.data.lcvMot.response,
                hgvMOT: res.data.hgvMOT.response,
                isMotExpiryDate: dateInPast(res.data.dvla?.response?.motExpiryDate),
                isAnnualTestExpiryDate: dateInPast(res.data.hgvMOT?.response?.annualTestExpiryDate),
                isResponse: true
            }));
            console.log(res, 'res');
        }
    };

    useEffect(() => {
        pullMotHistory();
    }, [props.regNo, props.FranchiseCode]);

    const fieldChange = (e) => {
        const { name, value } = e.target;
        setState((st) => {
            let newSt = { ...st };
            newSt[name] = value;
            return newSt;
        });
    };

    const handleSubmit = () => {
        pullMotHistory(state.regNumber, '');
    };

    return (
        <div className="mot-history-container">
            {!props.hideSeachText && (
                <Grid container alignItems="flex-end" spacing={2}>
                    <Grid item xs={12} sm={6} md={3} className="mandatoryfields">
                        <InputLabel shrink>Reg Number</InputLabel>
                        <TextBox autoFocus name="regNumber" onChange={fieldChange} value={state.regNumber} />
                        <span className="mandatoryfields">{state.errors['regNumber']}</span>
                    </Grid>
                    <Grid item xs={12} sm={2} md={1}>
                        <SecondaryButton className="Submitbtn" onClick={handleSubmit}>
                            GO
                        </SecondaryButton>
                    </Grid>
                </Grid>
            )}
            {state.isResponse && (
                <Grid container style={{ textAlign: 'left' }}>
                    {state.lcvMot != null ? (
                        <Grid container>
                            {state.isMotExpiryDate && (
                                <Grid item xs={12} style={{ backgroundColor: 'red', color: '#fff', textAlign: 'center' }}>
                                    <h1 style={{ color: '#fff' }}>This Vehicle's MOT has expired</h1>
                                    <h4 style={{ color: '#fff' }}>You can fined up to £1000 for Driving without a valid MOT</h4>
                                    <h4 style={{ color: '#fff' }}>
                                        This vehicle may be MOT exempt, for more information refer to
                                        <a
                                            style={{ color: '#fff !important', borderBottom: '1px solid #fff' }}
                                            target="_blank"
                                            href="https://assets.publishing.service.gov.uk/government/uploads/system/uploads/attachment_data/file/925057/v112-declaration-of-exemption-from-mot.pdf#page=2"
                                        >
                                            <b>MOT exemption guidance</b>
                                        </a>
                                    </h4>
                                </Grid>
                            )}
                            <Grid container item>
                                <Grid item xs={12}>
                                    <Grid
                                        container
                                        style={{
                                            padding: '0px 20px',
                                            ...(state.dvla.taxStatus == 'Untaxed' ? { color: '#fff', backgroundColor: 'red' } : {})
                                        }}
                                    >
                                        <Grid item xs={12}>
                                            <Grid container spacing={1}>
                                                <Grid item xs={3}>
                                                    <Grid item xs={12}>
                                                        Reg No
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <b>{state.lcvMot.registration}</b>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Grid item xs={12}>
                                                        Make/Model
                                                    </Grid>
                                                    <Grid xs={12}>
                                                        <b>{`${state.lcvMot.make} (${state.lcvMot.model})`}</b>
                                                    </Grid>
                                                </Grid>

                                                {state.lcvMot.motTests != null && (
                                                    <Grid item xs={3}>
                                                        <Grid item xs={12}>
                                                            Valid Until
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <b>{state.lcvMot.motTests[0].expiryDate}</b>
                                                        </Grid>
                                                    </Grid>
                                                )}
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Grid container spacing={1}>
                                                <Grid item xs={3}>
                                                    <Grid item xs={12}>
                                                        Tax Status
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <b>{state.dvla.taxStatus}</b>
                                                    </Grid>
                                                </Grid>
                                                {state.dvla.taxDueDate != null && (
                                                    <Grid item xs={6}>
                                                        <Grid item xs={12}>
                                                            Tax Due
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <b>{state.dvla.taxDueDate}</b>
                                                        </Grid>
                                                    </Grid>
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid container item xs={12}>
                                    {state.lcvMot.motTests != null ? (
                                        <Grid container item xs={12}>
                                            {state.lcvMot.motTests.map((q) => {
                                                return (
                                                    <Grid container item xs={12} style={{ padding: '10px 0px' }} spacing={1}>
                                                        <Grid item xs={12} className="text-center">
                                                            {`Test Date: ${q.completedDate}`}
                                                        </Grid>
                                                        <Grid item xs={12} className="table-responsive w-100">
                                                            <table className="table">
                                                                <thead>
                                                                    <tr className="text-uppercase small text-muted">
                                                                        <th scope="col">Result</th>
                                                                        <th scope="col">Test No.</th>
                                                                        <th scope="col">Mileage</th>
                                                                        <th scope="col">Expiry Date</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr className="mot_history_entry_result" scope="row">
                                                                        {q.testResult == 'PASSED' ? (
                                                                            <td>
                                                                                <span className="icon-container">
                                                                                    <CheckCircleIcon style={{ color: 'green' }} />
                                                                                </span>
                                                                                <span>
                                                                                    <strong className="text-success">Pass</strong>
                                                                                </span>
                                                                            </td>
                                                                        ) : (
                                                                            <td>
                                                                                <span className="icon-container">
                                                                                    <CancelIcon style={{ color: 'red' }} />
                                                                                </span>
                                                                                <span>
                                                                                    <strong className="text-success">Fail</strong>
                                                                                </span>
                                                                            </td>
                                                                        )}
                                                                        <td>{q.motTestNumber}</td>
                                                                        <td>{q.odometerValue}</td>
                                                                        <td>{q.expiryDate != null ? q.expiryDate : ''} </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </Grid>

                                                        {q.rfrAndComments != null && (
                                                            <Grid container spacing={2}>
                                                                {q.rfrAndComments.map((m) => {
                                                                    return (
                                                                        <Grid item xs={12}>
                                                                            {m.type == 'ADVISORY' ? (
                                                                                <Alert
                                                                                    style={{ textAlign: 'center' }}
                                                                                    severity="warning"
                                                                                    icon={<ErrorIcon fontSize="inherit" />}
                                                                                >
                                                                                    {m.text}
                                                                                </Alert>
                                                                            ) : m.type == 'PRS' ||
                                                                              m.type == 'FAILED' ||
                                                                              //   m.type == 'MAJOR' ||
                                                                              //   m.type == 'MINOR' ||
                                                                              q.testResult == 'FAILED' ? (
                                                                                <Alert severity="error" icon={<CancelIcon fontSize="inherit" />}>
                                                                                    {m.text}
                                                                                </Alert>
                                                                            ) : (
                                                                                <Alert severity="success" icon={<CheckCircleIcon fontSize="inherit" />}>
                                                                                    {m.text}
                                                                                </Alert>
                                                                            )}
                                                                        </Grid>
                                                                    );
                                                                })}
                                                            </Grid>
                                                        )}
                                                    </Grid>
                                                );
                                            })}
                                        </Grid>
                                    ) : (
                                        <Grid container>
                                            <Grid item xs={12}>
                                                <Alert severity="success" icon={<CheckCircleIcon fontSize="inherit" />}>
                                                    MOT records not available
                                                </Alert>
                                            </Grid>
                                        </Grid>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                    ) : state.hgvMOT != null ? (
                        <Grid container>
                            {state.isAnnualTestExpiryDate && (
                                <Grid item xs={12} style={{ backgroundColor: 'red', color: '#fff', textAlign: 'center' }}>
                                    <h1 style={{ color: '#fff' }}>This Vehicle's annual test has expired</h1>
                                    <br />
                                    <h4 style={{ color: '#fff' }}>
                                        If the vehicle has been tested recently, it can take up to 10 working day for DVSA to update records
                                    </h4>
                                    <br />
                                    <h4 style={{ color: '#fff' }}>
                                        This vehicle may be MOT exempt, for more information refer to
                                        <a
                                            style={{ color: '#fff !important', borderBottom: '1px solid #fff' }}
                                            target="_blank"
                                            href="https://www.gov.uk/government/publications/exemption-from-heavy-goods-vehicle-hgv-annual-testing-v112g?_ga=2.119468495.733291534.1605659116-1028051267.1603407825"
                                        >
                                            <b>MOT exemption guidance</b>
                                        </a>
                                    </h4>
                                </Grid>
                            )}
                            <Grid item xs={12}>
                                <Grid
                                    container
                                    style={{
                                        padding: '0px 20px',
                                        ...(state.dvla.taxStatus == 'Untaxed' ? { color: '#fff', backgroundColor: 'red' } : {})
                                    }}
                                >
                                    <Grid item xs={12}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={3}>
                                                <Grid item xs={12}>
                                                    Reg No
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <b>{state.hgvMOT.registration}</b>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Grid item xs={12}>
                                                    Make/Model
                                                </Grid>
                                                <Grid xs={12}>
                                                    <b>{`${state.hgvMOT.make} (${state.hgvMOT.model})`}</b>
                                                </Grid>
                                            </Grid>

                                            {state.hgvMOT.annualTestExpiryDate != null && (
                                                <Grid item xs={3}>
                                                    <Grid item xs={12}>
                                                        Valid Until
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <b>{state.hgvMOT.annualTestExpiryDate}</b>
                                                    </Grid>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={3}>
                                                <Grid item xs={12}>
                                                    Tax Status
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <b>{state.dvla.taxStatus}</b>
                                                </Grid>
                                            </Grid>
                                            {state.dvla.taxDueDate != null && (
                                                <Grid item xs={6}>
                                                    <Grid item xs={12}>
                                                        Tax Due
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <b>{state.dvla.taxDueDate}</b>
                                                    </Grid>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid container item xs={12}>
                                {state.hgvMOT.annualTests != null ? (
                                    <Grid container item xs={12}>
                                        {state.hgvMOT.annualTests.map((q) => {
                                            return (
                                                <Grid container item xs={12} style={{ padding: '10px 0px' }} spacing={1}>
                                                    <Grid item xs={12} className="text-center">
                                                        {`Test Date: ${q.testDate}`}
                                                    </Grid>
                                                    <Grid item xs={12} className="table-responsive w-100">
                                                        <table className="table">
                                                            <thead>
                                                                <tr className="text-uppercase small text-muted">
                                                                    <th scope="col">Result</th>
                                                                    <th scope="col">Test No.</th>
                                                                    <th scope="col">Expiry Date</th>
                                                                    <th scope="col">Location</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr className="mot_history_entry_result" scope="row">
                                                                    {q.testResult == 'Pass' ? (
                                                                        <td>
                                                                            <span className="icon-container">
                                                                                <CheckCircleIcon style={{ color: 'green' }} />
                                                                            </span>
                                                                            <span>
                                                                                <strong className="text-success">Pass</strong>
                                                                            </span>
                                                                        </td>
                                                                    ) : (
                                                                        <td>
                                                                            <span className="icon-container">
                                                                                <CancelIcon style={{ color: 'red' }} />
                                                                            </span>
                                                                            <span>
                                                                                <strong className="text-success">Fail</strong>
                                                                            </span>
                                                                        </td>
                                                                    )}
                                                                    <td>{q.testCertificateNumber}</td>
                                                                    <td>{q.expiryDate != null ? q.expiryDate : ''}</td>
                                                                    <td>{q.location}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </Grid>

                                                    {q.defects != null ? (
                                                        <Grid container spacing={2}>
                                                            {q.defects.map((m) => {
                                                                return (
                                                                    <Grid item xs={12}>
                                                                        {m.severityCode == 'A' ? (
                                                                            <Alert
                                                                                style={{ textAlign: 'center' }}
                                                                                severity="warning"
                                                                                icon={<ErrorIcon fontSize="inherit" />}
                                                                            >
                                                                                {`${m.failureReason}-${m.severityDescription}`}
                                                                            </Alert>
                                                                        ) : m.severityCode == 'F' ? (
                                                                            <Alert severity="error" icon={<CancelIcon fontSize="inherit" />}>
                                                                                {`${m.failureReason}-${m.severityDescription}`}
                                                                            </Alert>
                                                                        ) : (
                                                                            <Alert severity="success" icon={<CheckCircleIcon fontSize="inherit" />}>
                                                                                {`${m.failureReason}-${m.severityDescription}`}
                                                                            </Alert>
                                                                        )}
                                                                    </Grid>
                                                                );
                                                            })}
                                                        </Grid>
                                                    ) : q.testResult == 'Pass' ? (
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12}>
                                                                <Alert severity="success" icon={<CheckCircleIcon fontSize="inherit" />}>
                                                                    {`Passed MOT with no advisories`}
                                                                </Alert>
                                                            </Grid>
                                                        </Grid>
                                                    ) : (
                                                        ''
                                                    )}
                                                </Grid>
                                            );
                                        })}
                                    </Grid>
                                ) : (
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <Alert severity="success" icon={<CheckCircleIcon fontSize="inherit" />}>
                                                No MOT with no advisories
                                            </Alert>
                                        </Grid>
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                    ) : (
                        <Grid container>
                            <Grid item xs={12}>
                                <Alert severity="error" icon={<CancelIcon fontSize="inherit" />}>
                                    Resource not found
                                </Alert>
                            </Grid>
                        </Grid>
                    )}
                </Grid>
            )}
        </div>
    );
};

export default MotHistoryScreen;
